<h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>
  {{this.localiser.get("rules.deleteRuleTitle")}}
</h1>

<div mat-dialog-content class="bodyForm">
  <div class="reglaTable">
    <span class="textS">{{this.localiser.get("rules.name")}}: {{this.deleteRegla.nombre}}</span>
    
    <table style="width:100%; margin-top: 16px;">
      <tr class="bottom-border;" style="margin-bottom: 16px;">
        <th class="textS">{{this.localiser.get("menu.zones")}}</th>
      </tr>

      <div *ngIf="this.zonas.length > 0">
        <tr *ngFor="let zona of this.zonas" style="display: flex; align-items: center; justify-content: center; width: 100%;">
          <td class="textS">{{zona.nombre}}</td>
        </tr>
      </div>
      <tr *ngIf="this.zonas.length == 0" style="display: flex; align-items: center; justify-content: center; width: 100%;">
        <td class="textS">{{this.localiser.get("rules.delete.rule.no.zones")}}</td>
      </tr>

    </table>
  </div>
  
  <br>
  <h6 class="textS+" *ngIf="deleteRegla.activa">{{this.localiser.get("rules.deleteActiveRuleWarning")}}</h6>

</div>

<div mat-dialog-actions>
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
  </div>
  <div class="col" style="text-align: center">
    <button class="customButtonColorDelete textS" mat-button (click)="deleteSimple()">{{this.localiser.get("rules.deleteSimpleRule")}}</button>
  </div>
</div>
